import {gql} from '@apollo/client';

// this will be used for the board columns
export const itemStatusMutations = {
    CREATE_ITEM_STATUS: gql`
        mutation CreateItemStatus($input: ItemStatusCreateInput!) {
            createItemStatus(input: $input) {
                id
                title
                order
                color
                textColor
                statusType
                boardId
            }
        }
    `,
    UPDATE_ITEM_STATUS: gql`
        mutation UpdateItemStatus($input: ItemStatusUpdateInput!) {
            updateItemStatus(input: $input) {
                id
                title
                order
                color
                textColor
                statusType
                boardId
            }
        }
    `,
    REMOVE_ITEM_STATUSES_BY_IDS: gql`
        mutation RemoveItemStatusesByIds($ids: [UUID!]!) {
            removeItemStatusesByIds(ids: $ids) {
                message
                data
                success
                statusCode
            }
        }
    `,
    Remove_ITEM_STATUSES_BY_BOARD_ID: gql`
        mutation RemoveItemStatusesByBoardId($boardId: UUID!) {
            removeItemStatusesByBoardId(boardId: $boardId) {
                message
                data
                success
                statusCode
            }
        }
    `,
    SWAP_ITEM_STATUS_ORDER: gql`
        mutation SwapItemStatusesOrder($boardId: UUID!, $firstItem: UUID!, $secondItem: UUID!) {
            swapItemStatusesOrder(boardId: $boardId, firstItem: $firstItem, secondItem: $secondItem) {
                message
                data
                success
                statusCode
            }
        }
    `,
};
